import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {SNIPPETS_QUERY_KEY} from "../queryKeys";
import {ReachSnippet} from "./types";

type SyncSnippetVariables = {id: number};

const syncSnippetFromCio = async ({id}: SyncSnippetVariables): Promise<ReachSnippet> => {
  const response = await axiosReachInstance.post<ReachSnippet, AxiosResponse<ReachSnippet>>(`/snippets/${id}/sync-cio`);
  return response.data;
};

export const useSyncSnippetFromCio = (
  options?: BaseMutationOptions<ReachSnippet, SyncSnippetVariables>
): BaseUseMutationResult<ReachSnippet, SyncSnippetVariables> => {
  return useBaseMutation<ReachSnippet, SyncSnippetVariables>(syncSnippetFromCio, {
    ...options,
    prefixKeysToReset: () => [[SNIPPETS_QUERY_KEY]],
  });
};
